<template>
    <div :key="key">
        <div v-if="!editing" :class="reactiveClass" class="mt-1">
            <b-link title="Cliquer pour modifier" @click="edit">
                {{ displayValue }}
            </b-link>
        </div>
        <div v-if="editing" class="mt-0">
            <b-input-group>
                <b-input-group-prepend>
                    <b-button title="Annuler" size="sm" @click="display">
                        <i class="fas fa-fw fa-times"></i>
                    </b-button>
                </b-input-group-prepend>
                <b-input v-model="form.surname" size="sm" @change="update" />
            </b-input-group>
        </div>
    </div>
</template>

<script>
import TableFormHandler from '../../../../common/mixins/TableFormHandler.vue'

export default {
    name: 'SurnameForm',

    mixins: [TableFormHandler],

    props: {
        contact: null,
    },

    data() {
        return {
            editing: false,
        }
    },

    methods: {
        async update() {
            try {
                await this.$axios.put(
                    `/clientContacts/${this.contact.id}/physicalPersons/${this.contact.physical_person_id}`,
                    this.form
                )
                this.handleSuccess()
                this.setDisplayValue(this.form.surname)
                this.display()
                this.$emit('contact-has-changed')
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },

        initForm() {
            this.form.surname = this.contact.surname
            this.setDisplayValue(this.contact.surname)
            this.align = 'left'
        },

        setInitialKey() {
            this.key = `lastnameForm${this.contact.id}`
        },

        edit() {
            this.editing = true
        },

        display() {
            this.editing = false
        },
    },
}
</script>

<style scoped></style>
